<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <template v-slot:activator="{ on }">
      <v-icon color="green darken-2" v-on="on">mdi-camera</v-icon>
    </template>
    <v-card class="mx-auto">
      <v-card-title>
        <h3>Photo Information</h3>
      </v-card-title>

      <v-card-text>
        <div class="py-1">
          <span style="color: black">Title:</span>
          {{ data.title }}
        </div>
        <div class="py-1">
          <span style="color: black">Description:</span>
          {{ data.description }}
        </div>
        <div class="py-1">
          <span style="color: black">Taken:</span>
          {{ data.taken | moment}}
        </div>
        <v-divider class="my-2"></v-divider>
        <div class="py-1">
          <span style="color: black">Camera:</span>
          {{ data.camera }}
        </div>
        <div class="py-1">
          <span style="color: black">Lens:</span>
          {{ data.lens }}
        </div>
        <div class="py-1">
          <span style="color: black">Focal Length:</span>
          {{ data.focallength }}
        </div>
        <div class="py-1">
          <span style="color: black">ISO:</span>
          {{ data.iso }}
        </div>
        <div class="py-1">
          <span style="color: black">Aperture:</span>
          {{ data.aperture }}
        </div>
        <div class="py-1">
          <span style="color: black">Shutter Speed:</span>
          {{ data.speed }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  props: {
    data: {},
  },
  data() {
    return {
      dialog: false,
    };
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY:MM:DD hh:mm:ss").format('Do MMMM YYYY, h:mm a');
    }
  }
};
</script>

<style scoped></style>
